<template>
  <a-button style="padding: 0 !important" :type="btnType" :loading="loading" @click="download"
    >
    <slot>下载导入模板</slot>
    </a-button
  >
</template>

<script lang="ts">
import { defineComponent, reactive, toRefs } from "vue";
import { HttpService } from "../../core";
import { message } from "ant-design-vue";
import { saveAs } from "file-saver";
export default defineComponent({
  isGlobal: true,
  name: "DownloadTemplateBtn",
  props: {
    templateKey: {
      type: String,
      required: true,
    },
    btnType: {
      type: String,
      default: "link",
    },
  },
  setup(props) {
    const state = reactive({
      loading: false,
    });

    const download = async () => {
      state.loading = true;
      try {
        const r = await HttpService.backstageAxios({
          method: "GET",
          url: "/template/selectByBizType",
          params: { type: props.templateKey },
        });
        const res = r.data;
        if (res.respCode !== "0000") {
          return message.error(res.respDesc);
        }
        saveAs(res.data.url, res.data.description);
      } catch (e: any) {
        message.error(e.message);
      } finally {
        state.loading = false;
      }
    };

    return { ...toRefs(state), download };
  },
});
</script>
<style scoped lang="less">
:deep(.ant-btn-lin) {
  padding: 0 !important;
}
</style>
